import { Services } from "appworks/services/services";
import { TranslationsService } from "appworks/services/translations/translations-service";

export function PYLI18NSetup() {
    const translations = Services.get(TranslationsService);

    // translations.setUpperCase([
    //     "current_win"
    // ]);
}